export default {
  SET_ACTIVE_BLOCKCHAIN(state, payload) {
    state.activeBlockchain = payload
  },
}
